module.exports = __webpack_public_path__ + "static/media/mt-talinis.0e895e6b.jpg";